import { font, height, space } from 'nicollet-tokens';

/* eslint-disable unicorn/filename-case */
const fontSizes = size => {
  switch (size) {
    case 'lg':
      return font.size.text.large;

    case 'md':
      return font.size.text.base;

    case 'sm':
      return font.size.text.small;

    default:
      return font.size.text.base;
  }
};
const buttonHeight = size => {
  switch (size) {
    case 'lg':
      return height.button.lg;

    case 'sm':
      return height.button.sm;

    case 'md':
    default:
      return height.button.md;
  }
};
const paddingSize = size => {
  switch (size) {
    case 'lg':
      return space.generic.x4;

    case 'md':
      return space.generic.x3;

    case 'sm':
      return space.generic.x2;

    default:
      return space.generic.x3;
  }
};

export { buttonHeight, fontSizes, paddingSize };
